// src/contexts/NotificationContext.js
import React, { createContext, useState, useContext } from "react";

/**
 * NotificationContext holds a boolean (or a timestamp)
 * that signals "It's time to refresh notifications."
 */
const NotificationContext = createContext();

export function NotificationProvider({ children }) {
  // We'll store a simple boolean. You can also store
  // a timestamp or counter if you prefer.
  const [needsNotificationRefresh, setNeedsNotificationRefresh] = useState(false);

  return (
    <NotificationContext.Provider
      value={{ needsNotificationRefresh, setNeedsNotificationRefresh }}
    >
      {children}
    </NotificationContext.Provider>
  );
}

// Custom hook for easy usage
export function useNotificationRefresh() {
  return useContext(NotificationContext);
}
